import React, { useEffect, useReducer } from 'react';
import Grid from '@material-ui/core/Grid';
import { useHistory } from "react-router-dom";
import { Typography } from '@material-ui/core';
import Hidden from '@material-ui/core/Hidden';
import clsx from 'clsx';

import LearningContentsContext from '../../../context/learningContentContext/learningContents-context';
import learningContentReducer from '../../../reducers/learningContent-reducer';
import { GetLearningContentsByTraitGroupId, getLearningContentCategories } from '../../../actions/learningcontent-actions';
import LearningContentsRecommendHolder from './LearningContentsRecommendHolder';
import LearningContentsHolder from './LearningContentsHolder';
import { DefaultLayout, ProgressBarHeader, BreadcrumbsCustom } from '../../shared/component'
import LearningContentsCompleted from './LearningContentsCompleted';
import SmolLoading from '../../shared/SmolLoading';

import { getIconLearningContent } from '../../../utils/helpers/icon/iconHelper';
import useStyles from '../../../styles/components/learningcontent/stylesLearningContents'
import {
    getLearningContentFromSession,
    getLearningContentLevel,
    removeLearningContentFromSession,
    setLearningContentSession,
    setLearningContentLevel,
} from '../../../utils/helpers/others/SessionHelper';

const LearningContents = () => {
    const classes = useStyles();
    const history = useHistory();
    const [learningContentsContext, dispatch] = useReducer(learningContentReducer);
    const learningContentSession = JSON.parse(getLearningContentFromSession());
    const levelText = getLearningContentLevel();
    const [traitGroupId, setTraitGroupId] = React.useState(learningContentSession.learningContentCategoryId || 0)
    const [loading,setLoading] = React.useState(false);


    useEffect(() => {
        const initLearningContentCategories = async () => {
            const learningContentResponse = await getLearningContentCategories();
            if (learningContentResponse > 200 || learningContentResponse.status === "Failed") {
                return history.push("/SessionTimeOut")
            }

            const result = setupLearningContentCategories(learningContentResponse);
            dispatch({ type: 'SET_LEARNING_CONTENT_CATEGORIES', learningContentCategories: result });
        };
        initLearningContentCategories()
    }, []);

    useEffect(() => {
        const initLearningContents = async () => {
            const learningContentsResponse = await GetLearningContentsByTraitGroupId(learningContentSession.learningContentCategoryId);
            if (learningContentsResponse > 200 || learningContentsResponse.status === "Failed") {
                return history.push("/SessionTimeOut")
            }
            
            let completeCount = 0;
            let learningContentsVar = learningContentsResponse.data;
            let completedContents = [];
            let completedRecommendedLearningContentsCount = 0;
            let totalAvail = 0;
            Object.keys(learningContentsVar.traitCategoryAndLearningContents).map((index)=>{
                
                let testing = learningContentsVar.traitCategoryAndLearningContents[index].triatLearningContents.filter(test=>{
                    if(test.isCompleted){
                        completeCount++;
                        if(test.isRecommended)
                            completedRecommendedLearningContentsCount++;
                    }
                    else{
                        // if(!test.isRecommended)
                            totalAvail += 1;
                    }
                    return test.isCompleted;
                })
                completedContents.push({...learningContentsVar.traitCategoryAndLearningContents[index]});
                completedContents[index].triatLearningContents = testing;
            });
            dispatch({ type: 'SET_LEARNING_CONTENT_CATEGORY_ID', selectedLearningContentCategoryId: learningContentSession.learningContentCategoryId });
            dispatch({ type: 'SET_LEARNING_CONTENTS', learningContents: learningContentsVar.traitCategoryAndLearningContents });
            dispatch({ type: 'SET_RECOMMEND_LEARNING_CONTENTS', recommendLearningContents: learningContentsVar.recommendedLearningContents });
            dispatch({type: 'SET_COMPLETED_RECOMMENDED_LEARNING_CONTENTS_COUNT', completedRecommendedLearningContentsCount:completedRecommendedLearningContentsCount });
            dispatch({ type: 'SET_AVAILABLE_LEARNING_CONTENTS_COUNT', availableLearningContentsCount: totalAvail});
            dispatch({ type: 'SET_COMPLETED_LEARNING_CONTENTS_COUNT',completeCount : completeCount})
            setLoading(false);
        }
        setLoading(true);
        initLearningContents();
    }, [traitGroupId])

    const setupLearningContentCategories = (learningContentCategories) => {
        let learningContentCategoriesCustom = learningContentCategories.data.map((learningContentCat) => {
            if (learningContentCat.traitGroupName == 'Promotion of Well-being') {
                learningContentCat.logoPath = getIconLearningContent().img_lc_promotion;
                //learningContentCat.logoPath = "./assets/images/components/shared/traits/wellbeing/UI_CityIcon_Wellbeing-min.png";
            }
            else if (learningContentCat.traitGroupName == 'Mindset') {
                learningContentCat.logoPath = getIconLearningContent().img_lc_mindset;
                //learningContentCat.logoPath = "./assets/images/components/shared/traits/mindset/UI_CityIcon_Mindset-min.png";
            }
            else if (learningContentCat.traitGroupName == 'Grit and Resilience') {
                learningContentCat.logoPath = getIconLearningContent().img_lc_grit_resilience;
                //learningContentCat.logoPath = "./assets/images/components/shared/traits/resilience/UI_CityIcon_Resilience-min.png";
            }
            else if (learningContentCat.traitGroupName == 'Approaches to Learning and Studying') {
                learningContentCat.logoPath = getIconLearningContent().img_lc_approaches;
                //learningContentCat.logoPath = "./assets/images/components/shared/traits/learning/UI_CityIcon_Learning-min.png";
            }

            if (learningContentSession.learningContentCategoryId === learningContentCat.traitGroupId) {
                setLearningContentLevel(learningContentCat.levelText);
            }
            return learningContentCat;
        });

        const result = learningContentCategoriesCustom.map(obj1 => ({
            ...learningContentCategories.data.find((item) => (item.traitGroupId === obj1.traitGroupId) && item),
            ...obj1
        }));

        return result;
    }

    const handleClickTabs = (item) => {
        setTraitGroupId(item.traitGroupId)
        const learningContent = {
            learningContentCategoryId: item.traitGroupId,
            learningContentCategoryName: item.traitGroupName,
            levelText: item.levelText > 0 ? item.levelText : 0,
            learningContentId: null
        };
        removeLearningContentFromSession();
        setLearningContentLevel(item.levelText > 0 ? item.levelText : 0)
        setLearningContentSession(JSON.stringify(learningContent));
    }

    const breadcrumbsData = [
        {
            text: 'Learning Resources',
            href: '/LearningContentCategories'
        },
        {
            text: learningContentSession.learningContentCategoryName,
            href: ''
        },
    ];

    return (
        <LearningContentsContext.Provider value={{ learningContentsContext, dispatch }}>
            <DefaultLayout
                title={learningContentSession.learningContentCategoryName}
                type='Learning Content'
                description=''
                image={getIconLearningContent().img_lc_bg_header}
                progressBar={<ProgressBarHeader levelText={levelText > 5 ? 5 : levelText} isExtraMax={levelText > 5 ? true : false} />}
            >
                    <Grid container>
                        <Grid item xs={3} classes={{ root: classes.rootGridTabsContainer }} >
                            {learningContentsContext && learningContentsContext.learningContentCategories.length !== 0 &&
                                learningContentsContext.learningContentCategories.map((item, idx) => (
                                    <Hidden mdDown key={idx}>
                                        <Grid
                                            classes={{ root: classes.rootWrapperTab }}
                                            className={clsx(traitGroupId === item.traitGroupId && classes.rootWrapperTabActive)}
                                            container
                                            justify="flex-end"
                                            onClick={() => handleClickTabs(item)}>
                                            <Grid
                                                container
                                                item
                                                lg={12} xl={10}
                                                justify="center"
                                                alignItems="center"
                                                classes={{ root: classes.rootGridTab }}
                                            >
                                                <div className={classes.containerImage}>
                                                    <img src={`${item.logoPath}`} />
                                                </div>
                                                <div className={classes.containerContent}>
                                                    {item.traitGroupName}
                                                </div>
                                            </Grid>
                                        </Grid>
                                    </Hidden>
                                ))
                            }
                        </Grid>
                        <Grid item xs={12} md={6} classes={{ root: classes.rootGridContentContainer }}>
                            <BreadcrumbsCustom breadcrumbsData={breadcrumbsData} />
                            <Grid classes={{ root: classes.rootGridDescription }}>
                                <Typography classes={{ root: classes.rootContent }}>Please choose a learning resource to begin</Typography>
                            </Grid>
                            {loading ? <SmolLoading></SmolLoading>
                            :
                            <>
                                <LearningContentsRecommendHolder />
                                <LearningContentsHolder/>
                                {/* <LearningContentsCompleted> */}
                            </>
                            }
                        </Grid>
                    </Grid>
            </DefaultLayout>
        </LearningContentsContext.Provider>
    )
};

export default LearningContents;